// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contact Page Responsive Styles */

/* ==========================================
   Extra Large Desktops (1536px and down)
   ========================================== */
@media screen and (max-width: 1728px) {
  .scl--web-page-contact-contact-section {
    padding: 120px var(--global-laptop-padding-left);
  }

}

/* ==========================================
   Large Laptops (1440px and down)
   ========================================== */
@media screen and (max-width: 1440px) {
  .scl--web-page-contact-contact-section {
    padding: 120px var(--global-laptop-padding-left);
  }

  .scl--web-page-contact-title-section {
    max-width: 100%;
  }

  .scl--web-page-contact-cards-wrapper {
    gap: 40px;
  }
}

/* ==========================================
   Small Laptops (1280px and down)
   ========================================== */
@media screen and (max-width: 1280px) {
  .scl--web-page-contact-contact-section {
    padding: 100px var(--global-laptop-padding-left);
    min-height: auto;
  }
  .scl--web-page-contact-cards-wrapper .scl--web-component-contact-card-description{
    padding-right: 20px;
  }
  .scl--web-page-contact-title-section {
    max-width: 100%;
  }

  /* Cards Wrapper - Vertical Stack */
  .scl--web-page-contact-cards-wrapper {
    flex-direction: column;
    gap: 60px;
    align-items: stretch;
  }

  /* Add left border for portrait layout */
  .scl--web-page-contact-cards-wrapper > * {
    border-right: none;
    border-left: 1px solid rgba(125, 129, 135, 0.3);
    padding-left: 40px;
  }

  .scl--web-page-contact-cards-wrapper > *:last-child {
    border-bottom: none;
    border-right: 1px solid rgba(125, 129, 135, 0.3);
  }

  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-content-wrapper {
    max-width: 100%;
    width: 100%;
  }

  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-container {
    max-width: 100%;
    width: 100%;
  }
}

/* ==========================================
   Tablets (850px and down)
   ========================================== */
@media screen and (max-width: 850px) {
  .scl--web-page-contact-contact-section {
    padding: 80px var(--global-tablet-padding-left);
    min-height: auto;
  }
 
  /* Title Section */
  .scl--web-page-contact-title-section {
    gap: 20px;
    max-width: 778px;
    padding-top: 40px;
    margin-bottom: 58px;
  }

  .scl--web-page-contact-main-title {
    font-size: 70px;
    line-height: 110px;
    letter-spacing: -1.68px;
  }

  .scl--web-page-contact-subtitle {
    font-size: 28px;
    line-height: 30px;
  }
  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-content-wrapper {
    gap: 20px;
    max-width: 100% !important;
    width: 100% !important;
    border-right: none;
    min-height: auto;
  }

  .scl--web-page-contact-cards-wrapper > *:not(:last-child){
    border: none;
  }

  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-container {
    max-width: 100% !important;
    width: 100% !important;
    min-height: auto;
    padding: 0;
  }

  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-inner {
    min-height: auto;
  }

  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-text-container {
    max-width: 100% !important;
    width: 100% !important;
    gap: 41px;
  }

  /* Cards Wrapper - Vertical Stack */
  .scl--web-page-contact-cards-wrapper {
    flex-direction: column;
    gap: 70px;
    max-width: 777px;
    align-items: stretch;
  }

  /* Remove border from card container */
  .scl--web-page-contact-cards-wrapper > * {
    border-right: none;
    border-bottom: none;
    border-left: none;
  }

  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-title {
    font-size: 40px;
    line-height: 100%;
  }

.scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-description{
  font-size: 28px;
  width: 100%;
  line-height: 30px;

}

  /* Button Styles - 850px */
  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-styled-button {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 16px 20px;
    gap: 11px;
    min-width: 453px;
    height: 60px;
    background: #282828;
    border: 1.5px solid #797979;
    border-radius: 30px;
  }

  .scl--web-page-contact-cards-wrapper > *:last-child{
    border: none;
  }

  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-styled-button span:first-child {
    height: 31px;
    font-size: 28px;
    line-height: 29px;
    text-align: center;
    color: #FFFFFF;
  }

}

/* ==========================================
   Large Phones (430px and down)
   ========================================== */
@media screen and (max-width: 500px) {
  .scl--web-page-contact-contact-section {
    padding: 90px var(--global-mobile-padding-left);
    min-height: auto;
  }

  .scl--web-page-contact-title-section {
    margin-bottom: 40px;
  }

  .scl--web-page-contact-main-title {
    font-size: 55px;
    line-height: 130%;
  }

  .scl--web-page-contact-subtitle {
    font-size: 24px;
    line-height: 145%;
  }

  .scl--web-page-contact-cards-wrapper {
    gap: 70px;
  }

  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-title {
    font-size: 32px;
    line-height: 100%;
  }
  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-container {
    padding-left: 0px;
  }
  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-text-container{
    gap: 20px;
  }
  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-content-wrapper {
    gap: 0;
    border: none;
  }
  .scl--web-page-contact-cards-wrapper > *:not(:last-child){
    border: none;
    border-right: none;
  }
  .scl--web-page-contact-cards-wrapper > *:last-child {
    border: none
  }
  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-description{
    font-size: 24px;
    width: 100%;
    padding: 0px;
  }

  /* Button Styles - 500px */
  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-styled-button {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 16px 0px;
    gap: 11px;
    width: 100%;
    height: 56px;
    background: #282828;
    border: 1.5px solid #797979;
    border-radius: 30px;
  }

  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-styled-button span:first-child {
    height: 31px;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    color: #FFFFFF;
  }

}

`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/contact/css/contactResponsive.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;;+CAE+C;AAC/C;EACE;IACE,gDAAgD;EAClD;;AAEF;;AAEA;;+CAE+C;AAC/C;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;;+CAE+C;AAC/C;EACE;IACE,gDAAgD;IAChD,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;;EAEA,mCAAmC;EACnC;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA,wCAAwC;EACxC;IACE,kBAAkB;IAClB,+CAA+C;IAC/C,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,gDAAgD;EAClD;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;;+CAE+C;AAC/C;EACE;IACE,+CAA+C;IAC/C,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,SAAS;EACX;;EAEA,mCAAmC;EACnC;IACE,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA,sCAAsC;EACtC;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;AAEF;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;;AAEnB;;EAEE,0BAA0B;EAC1B;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;AAEF;;AAEA;;+CAE+C;AAC/C;EACE;IACE,+CAA+C;IAC/C,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,MAAM;IACN,YAAY;EACd;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE;EACF;EACA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA,0BAA0B;EAC1B;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;AAEF","sourcesContent":["/* Contact Page Responsive Styles */\n\n/* ==========================================\n   Extra Large Desktops (1536px and down)\n   ========================================== */\n@media screen and (max-width: 1728px) {\n  .scl--web-page-contact-contact-section {\n    padding: 120px var(--global-laptop-padding-left);\n  }\n\n}\n\n/* ==========================================\n   Large Laptops (1440px and down)\n   ========================================== */\n@media screen and (max-width: 1440px) {\n  .scl--web-page-contact-contact-section {\n    padding: 120px var(--global-laptop-padding-left);\n  }\n\n  .scl--web-page-contact-title-section {\n    max-width: 100%;\n  }\n\n  .scl--web-page-contact-cards-wrapper {\n    gap: 40px;\n  }\n}\n\n/* ==========================================\n   Small Laptops (1280px and down)\n   ========================================== */\n@media screen and (max-width: 1280px) {\n  .scl--web-page-contact-contact-section {\n    padding: 100px var(--global-laptop-padding-left);\n    min-height: auto;\n  }\n  .scl--web-page-contact-cards-wrapper .scl--web-component-contact-card-description{\n    padding-right: 20px;\n  }\n  .scl--web-page-contact-title-section {\n    max-width: 100%;\n  }\n\n  /* Cards Wrapper - Vertical Stack */\n  .scl--web-page-contact-cards-wrapper {\n    flex-direction: column;\n    gap: 60px;\n    align-items: stretch;\n  }\n\n  /* Add left border for portrait layout */\n  .scl--web-page-contact-cards-wrapper > * {\n    border-right: none;\n    border-left: 1px solid rgba(125, 129, 135, 0.3);\n    padding-left: 40px;\n  }\n\n  .scl--web-page-contact-cards-wrapper > *:last-child {\n    border-bottom: none;\n    border-right: 1px solid rgba(125, 129, 135, 0.3);\n  }\n\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-content-wrapper {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-container {\n    max-width: 100%;\n    width: 100%;\n  }\n}\n\n/* ==========================================\n   Tablets (850px and down)\n   ========================================== */\n@media screen and (max-width: 850px) {\n  .scl--web-page-contact-contact-section {\n    padding: 80px var(--global-tablet-padding-left);\n    min-height: auto;\n  }\n \n  /* Title Section */\n  .scl--web-page-contact-title-section {\n    gap: 20px;\n    max-width: 778px;\n    padding-top: 40px;\n    margin-bottom: 58px;\n  }\n\n  .scl--web-page-contact-main-title {\n    font-size: 70px;\n    line-height: 110px;\n    letter-spacing: -1.68px;\n  }\n\n  .scl--web-page-contact-subtitle {\n    font-size: 28px;\n    line-height: 30px;\n  }\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-content-wrapper {\n    gap: 20px;\n    max-width: 100% !important;\n    width: 100% !important;\n    border-right: none;\n    min-height: auto;\n  }\n\n  .scl--web-page-contact-cards-wrapper > *:not(:last-child){\n    border: none;\n  }\n\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-container {\n    max-width: 100% !important;\n    width: 100% !important;\n    min-height: auto;\n    padding: 0;\n  }\n\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-inner {\n    min-height: auto;\n  }\n\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-text-container {\n    max-width: 100% !important;\n    width: 100% !important;\n    gap: 41px;\n  }\n\n  /* Cards Wrapper - Vertical Stack */\n  .scl--web-page-contact-cards-wrapper {\n    flex-direction: column;\n    gap: 70px;\n    max-width: 777px;\n    align-items: stretch;\n  }\n\n  /* Remove border from card container */\n  .scl--web-page-contact-cards-wrapper > * {\n    border-right: none;\n    border-bottom: none;\n    border-left: none;\n  }\n\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-title {\n    font-size: 40px;\n    line-height: 100%;\n  }\n\n.scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-description{\n  font-size: 28px;\n  width: 100%;\n  line-height: 30px;\n\n}\n\n  /* Button Styles - 850px */\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-styled-button {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 16px 20px;\n    gap: 11px;\n    min-width: 453px;\n    height: 60px;\n    background: #282828;\n    border: 1.5px solid #797979;\n    border-radius: 30px;\n  }\n\n  .scl--web-page-contact-cards-wrapper > *:last-child{\n    border: none;\n  }\n\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-styled-button span:first-child {\n    height: 31px;\n    font-size: 28px;\n    line-height: 29px;\n    text-align: center;\n    color: #FFFFFF;\n  }\n\n}\n\n/* ==========================================\n   Large Phones (430px and down)\n   ========================================== */\n@media screen and (max-width: 500px) {\n  .scl--web-page-contact-contact-section {\n    padding: 90px var(--global-mobile-padding-left);\n    min-height: auto;\n  }\n\n  .scl--web-page-contact-title-section {\n    margin-bottom: 40px;\n  }\n\n  .scl--web-page-contact-main-title {\n    font-size: 55px;\n    line-height: 130%;\n  }\n\n  .scl--web-page-contact-subtitle {\n    font-size: 24px;\n    line-height: 145%;\n  }\n\n  .scl--web-page-contact-cards-wrapper {\n    gap: 70px;\n  }\n\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-title {\n    font-size: 32px;\n    line-height: 100%;\n  }\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-container {\n    padding-left: 0px;\n  }\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-text-container{\n    gap: 20px;\n  }\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-content-wrapper {\n    gap: 0;\n    border: none;\n  }\n  .scl--web-page-contact-cards-wrapper > *:not(:last-child){\n    border: none;\n    border-right: none;\n  }\n  .scl--web-page-contact-cards-wrapper > *:last-child {\n    border: none\n  }\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-description{\n    font-size: 24px;\n    width: 100%;\n    padding: 0px;\n  }\n\n  /* Button Styles - 500px */\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-styled-button {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 16px 0px;\n    gap: 11px;\n    width: 100%;\n    height: 56px;\n    background: #282828;\n    border: 1.5px solid #797979;\n    border-radius: 30px;\n  }\n\n  .scl--web-page-contact-get-in-touch-section .scl--web-component-contact-styled-button span:first-child {\n    height: 31px;\n    font-size: 24px;\n    line-height: 29px;\n    text-align: center;\n    color: #FFFFFF;\n  }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
